import { useWorkloadOptimizationAgentStatus } from 'features/workload-optimization';

import {
  minimumWoopAgentVersionForAutoInstrument,
  minimumWoopAgentVersionForDeferredMode,
  minimumWoopAgentVersionForHpa,
  minimumWoopAgentVersionForRestartPodsOneByOne,
  minimumWoopAgentVersionForSingleResource,
  minimumWoopAgentVersionForZeroDowntime,
} from '../_constants';
import { isVersionOutdated } from '../_versionUtils';

export const useVersionsInfo = () => {
  const {
    currentVersion,
    latestVersion,
    hpaSupportedFromCastAgentVersion,
    castAgentCurrentVersion,
    nativeHpaSupportedFromVersion,
    hpaConvertersSupportedFromVersion,
    isLoading: woopVersionLoading,
    error: woopVersionError,
  } = useWorkloadOptimizationAgentStatus();

  const isWoopAgentOutdatedForHpa = isVersionOutdated(
    currentVersion || undefined,
    minimumWoopAgentVersionForHpa
  );

  const isCastAgentOutdatedForHpa = isVersionOutdated(
    castAgentCurrentVersion || undefined,
    hpaSupportedFromCastAgentVersion || undefined
  );

  const isDeferredModeCannotBeUsed = isVersionOutdated(
    currentVersion || undefined,
    minimumWoopAgentVersionForDeferredMode
  );

  const isSingleResourceModeCannotBeUsed = isVersionOutdated(
    currentVersion || undefined,
    minimumWoopAgentVersionForSingleResource
  );

  const isZeroDowntimeCannotBeUsed = isVersionOutdated(
    currentVersion || undefined,
    minimumWoopAgentVersionForZeroDowntime
  );

  const isRestartPodsOneByOneCannotBeUsed = isVersionOutdated(
    currentVersion || undefined,
    minimumWoopAgentVersionForRestartPodsOneByOne
  );

  const isAutoInstrumentCannotBeUsed = isVersionOutdated(
    currentVersion || undefined,
    minimumWoopAgentVersionForAutoInstrument
  );

  const isNativeHpaCannotBeUsed = isVersionOutdated(
    currentVersion || undefined,
    nativeHpaSupportedFromVersion || undefined
  );

  const isHpaConverterCannotBeUsed = isVersionOutdated(
    currentVersion || undefined,
    hpaConvertersSupportedFromVersion || undefined
  );

  return {
    isWoopAgentOutdatedForHpa,
    isCastAgentOutdatedForHpa,
    isDeferredModeCannotBeUsed,
    castAgentCurrentVersion,
    hpaSupportedFromCastAgentVersion,
    nativeHpaSupportedFromVersion,
    hpaConvertersSupportedFromVersion,
    woopVersionLoading,
    woopVersionError,
    isSingleResourceModeCannotBeUsed,
    isZeroDowntimeCannotBeUsed,
    isRestartPodsOneByOneCannotBeUsed,
    isNativeHpaCannotBeUsed,
    isAutoInstrumentCannotBeUsed,
    isHpaConverterCannotBeUsed,
    latestVersion,
  };
};
